__turbopack_context__.v({
  "blockWrapper": "PlatformForm-module__BC_FOG__blockWrapper",
  "border": "PlatformForm-module__BC_FOG__border",
  "donationAmountInput": "PlatformForm-module__BC_FOG__donationAmountInput",
  "donationFormContent": "PlatformForm-module__BC_FOG__donationFormContent",
  "donationFormNotices": "PlatformForm-module__BC_FOG__donationFormNotices",
  "formFieldsContainer": "PlatformForm-module__BC_FOG__formFieldsContainer",
  "headingMargin": "PlatformForm-module__BC_FOG__headingMargin",
});
